import { useQuery, UseQueryOptions } from 'react-query'
import { useAxiosContext } from '@dc-shared-web/providers/AxiosProvider'
import { ProcessingDocument } from '@dc-shared-web/lib/cubeMappers'
import {
  fetchProcessingDocuments,
  ProcessingDocumentParams,
} from '@dc-shared-web/hooks/api/document/fetchProcessingDocuments'

type ProcessingDocumentQueryKey = [
  'processingDocument',
  { [k: string]: string | number | string[] },
]

export const useGetProcessingDocuments = (
  params: ProcessingDocumentParams,
  enableRefetch?: boolean,
  options?: Omit<
    UseQueryOptions<
      ProcessingDocument[],
      Error,
      ProcessingDocument[],
      ProcessingDocumentQueryKey
    >,
    'queryKey' | 'queryFn'
  >
) => {
  const apiClient = useAxiosContext()
  const nonEmptyParams = Object.fromEntries(
    Object.entries(params).filter(([, value]) => Boolean(value))
  )
  return useQuery({
    queryKey: ['processingDocument', nonEmptyParams],
    queryFn: () => fetchProcessingDocuments(apiClient, params),
    refetchInterval: enableRefetch ? 5000 : undefined,
    ...options,
  })
}
